import { render, staticRenderFns } from "./CardDetails.vue?vue&type=template&id=522861de&scoped=true&"
import script from "./CardDetails.vue?vue&type=script&lang=ts&"
export * from "./CardDetails.vue?vue&type=script&lang=ts&"
import style0 from "./CardDetails.vue?vue&type=style&index=0&id=522861de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522861de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('522861de')) {
      api.createRecord('522861de', component.options)
    } else {
      api.reload('522861de', component.options)
    }
    module.hot.accept("./CardDetails.vue?vue&type=template&id=522861de&scoped=true&", function () {
      api.rerender('522861de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/CardDetails.vue"
export default component.exports